require('core-js/fn/object/values');
require('core-js/fn/object/assign');
require('core-js/fn/array/find');
require('core-js/fn/array/find-index');
require('core-js/fn/array/from');
require('core-js/fn/promise');
require('srcdoc-polyfill');
require('whatwg-fetch');


// WEBPACK FOOTER //
// ./src/Services/Misc/Polyfills.js